// projects_data.js
// project_data[0] = IOT/ELE projects
// project_data[1] = AI/ML projects
// project_data[2] = Web Design projects
// project_data[3] = Programming Languages
import downlaods from '../Images/download.jpg'
import vr from '../Images/vr.jpeg'
import mi_vr from '../Images/mini_vr.jpeg'
import nidi from '../Images/nidhi_com.jpeg'
import amazon from '../Images/amazn.jpeg'
import cat_vs_dog from '../Images/cat_vs_dog-mini.png'
import finace_agent_com from '../Images/finace_agent_com.png'
import gymsite from '../Images/gymsite.png'
import qa_bot from '../Images/qa_bot.jpeg'
import llmbot from '../Images/llm_bot.png'
import moviesite from '../Images/moviesite.jpeg'
import weather from '../Images/weather-mini.png'
import mulitmodal from '../Images/multimodalbot.png'


import cat_vs_dog_doc from '../../src/data/Project_Report_C_vs_D.pdf'
import steamlit from '../../src/data/Documentation_Streamlit_AI_Agent.pdf'
import RAG from '../../src/data/Agentic_RAG_System_System_Design_Document.pdf'
import med_bot_doc from '../../src/data/Medical-Bot-V2.pdf'


export const project_data = [
  // [0] IOT/ELE
  [
    {
      pro_name: 'ESP Local Server',
      pro_des: 'Using diffrent types of sensor to make automation',
      pro_img: downlaods,
      proj_link: '',
      proj_docs: '',
    },
    // {
    //   pro_name: 'ESP-32 Sensors',
    //   pro_des: 'simple local area network using esp-32. It is able to connect through wifi and also as local server',
    //   pro_img: '',
    //   proj_link: '',
    //   proj_docs: '',
    // },
    {
      pro_name: 'Mini Votage Regulator',
      pro_des: 'A small pocket voltage regulator capable of regulating upto 20v dc',
      pro_img: mi_vr,
      proj_link: '',
      proj_docs: '',
    },
    {
      pro_name: 'Voltage Regulator',
      pro_des: 'A powerfull voltage-current regulator and stabilizer with display capable of converting 220v AC to DC a maximum output of 30 volts and 10 amps',
      pro_img: vr,
      proj_link: 'https://github.com/',
      proj_docs: '',
    },
  ],
  // [1] AI/ML
  [
    {
      pro_name: 'Virtual Assitant (Nidhi)(present) ',
      pro_des: 'Developing a virtual assistant capable of performing various advance tasks',
      pro_img: nidi,
      proj_link: 'https://github.com/',
      proj_docs: '',
    },
    {
      pro_name: 'Image Classifier',
      pro_des: 'Developed and deployed a deep learning model to accurately classify images as cats or dogs.',
      pro_img: cat_vs_dog,
      proj_link: 'https://catvsdog.sharadsnaik.in',
      proj_docs: cat_vs_dog_doc,
    },
    {
      pro_name: 'Multi-Modal AI',
      pro_des: 'Developed and deployed with zero cost  multimodal AI platform with peak optimization 😁.',
      pro_img: mulitmodal,
      proj_link: 'https://ragchatbot.sharadsnaik.in/',
      proj_docs: '',
    },
    {
      pro_name: 'AI Applications',
      pro_des: 'A fully functional chatbots powered by an LLM models, fine-tunned Quantized model capable of supporting various data formats, including TXT, PDF, JSON, and more.Collaborative filtering-based recommendation engine.',
      pro_img: llmbot ,
      proj_link: 'https://conversationaimodel.netlify.app/',
      proj_docs: med_bot_doc
    },
    {
      pro_name: 'Finance Agent',
      pro_des: 'finance-focused AI agent capable of fetching real-time stock data. Integrated a Human-in-the-Loop feature to allow manual review and more.',
      pro_img: finace_agent_com,
      proj_link: 'https://fiinanceagentic.streamlit.app/',
      proj_docs: steamlit,
    },
    {
      pro_name: 'Agentic RAG',
      pro_des: 'True Agentic RAG with LangGraph & MCP.',
      pro_img: qa_bot,
      proj_link: 'https://github.com/shardsnaik/agentic_rag_system',
      proj_docs: RAG,
    },
    // {
    //   pro_name: 'Chatbot',
    //   pro_des: 'Conversational AI chatbot using transformer architecture.',
    //   pro_img: '',
    //   proj_link: 'https://github.com/',
    //   proj_docs: '',
    // },
  ],
  // [2] Web Design
  [
    {
      pro_name: 'Weather app',
      pro_des: 'its shows the weather data of our area by putting pincode, it basically serves through api.',
      pro_img: weather,
      proj_link: 'https://weather-app-sage-ten-35.vercel.app/',
      proj_docs: '',
    },
    {
      pro_name: 'Amazon clone',
      pro_des: 'just front end clone of the amazon site',
      pro_img: amazon,
      proj_link: 'https://shardsnaik.github.io/amzon_clone/',
      proj_docs: '',
    },
    {
      pro_name: 'Moviehub',
      pro_des: 'Front end movie site designed through html, css and javascript',
      pro_img: moviesite,
      proj_link: 'https://shardsnaik.github.io/webDesigning/',
      proj_docs: '',
    },
    // {
    //   pro_name: 'Gym site',
    //   pro_des: 'Gym website using react-js.',
    //   pro_img: gymsite,
    //   proj_link: 'https://github.com/',
    //   proj_docs: '',
    // },
  ],
  // [3] Programming Languages — each entry has lang_img, lang_img2, lang_img3
  [
    { lang_img: '', lang_img2: '', lang_img3: '' },
    { lang_img: '', lang_img2: '', lang_img3: '' },
  ],
];
